<template>
<div>
    <div class="pgemnt-2">
        <div class="header">
           
            <el-button class="newAdd" type="primary" @click="btnTrans('add')" size="mini">添加父级</el-button>
             <el-button size="mini" class=" goIcon">
                <a href="https://www.iconfont.cn/manage/index?spm=a313x.7781069.1998910419.13&manage_type=myprojects&projectId=1055673" target="_black">icon</a>
            </el-button>
        </div>
        <div class="tbs">

            <el-table :data="showArr" style="width: 100%">
                <el-table-column label="名称">
                    <template slot-scope="scope">
                        <span class="goDeeper" @click="preFmate(scope.row)">
                            <span :style="'margin-left:' + 24 * scope.row.x.length + 'px'">
                                <span style="margin-left: -18px" v-if="scope.row.getMenuModules.length > 0">
                                    <i class="el-icon-caret-right" v-if="scope.row.hide"></i>
                                    <i class="el-icon-caret-bottom" v-else></i>
                                </span>
                                {{ scope.row.name }}
                                <template v-if="scope.row.description">[{{ scope.row.description }}]</template>
                            </span>
                            <span class="tbIcon" v-if="scope.row.getMenuModules.length > 0">( {{ scope.row.getMenuModules.length }} )</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="类型" width="180">
                    <template slot-scope="scope">
                        <span class="goDeeper">{{scope.row.type | translate("type")}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="显示">
                    <template slot-scope="scope">
                        <span class="goDeeper">{{scope.row.view | translate("view")}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" width="240" label="操作">

                    <template slot-scope="scope">
                        <div class=""></div>
                        <el-button type="primary" @click="btnTrans('add', scope.row)" size="mini">添加</el-button>
                        <el-button type="danger" @click="btnTrans('edit', scope.row)" size="mini">编辑</el-button>
                        <el-button type="warning" @click="btnTrans('remove', scope.row)" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog :title="diaTitle" class="pgemnt-2-dag" :visible.sync="diaForAdd" width="450px" center>
            <table>
                <tr>
                    <td class="inpName">
                        <div>类型：</div>
                    </td>
                    <td>
                        <div class="inContent">
                            <template>
                                <el-radio v-model="postDats.type" :label="1">页面</el-radio>
                                <el-radio v-model="postDats.type" :label="2">按钮</el-radio>
                            </template>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="inpName">
                        <div>显示：</div>
                    </td>
                    <td>
                        <div class="inContent">
                            <template>
                                <el-radio v-model="postDats.view" :label="1">显示</el-radio>
                                <el-radio v-model="postDats.view" :label="2">不显示</el-radio>
                            </template>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="inpName">
                        <div>名称：</div>
                    </td>
                    <td>
                        <div class="inContent">
                            <el-input size="medium" v-model="postDats.name"></el-input>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="inpName">
                        <div>菜单URL：</div>
                    </td>
                    <td>
                        <div class="inContent">
                            <el-input size="medium" v-model="postDats.url"></el-input>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="inpName">
                        <div>图标URL：</div>
                    </td>
                    <td>
                        <div class="inContent">
                            <el-input size="medium" v-model="postDats.iconUrl"></el-input>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="inpName">
                        <div>描述：</div>
                    </td>
                    <td>
                        <div class="inContent">
                            <el-input size="medium" v-model="postDats.description"></el-input>
                        </div>
                    </td>
                </tr>
            </table>

            <span slot="footer" class="dialog-footer">
                <el-button @click="diaForAdd = false" size="small">取 消</el-button>
                <el-button class="inContent" type="primary" @click="goSave()" size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</div>
</template>

<script>
import {
    menuCreate,
    getMenu,
    delDot
} from '@/api/pgMent/modelSet';
export default {
    data() {
        return {
            loading: false,
            tableData: [],

            storeArr: [],
            showArr: [],

            //  弹出层

            diaForAdd: false,
            radio1: '',
            radio2: '',
            diaTitle: '',

            postDats: {
                id: '',
                pId: '',
                iconUrl: '',
                name: '',
                type: '',
                url: '',
                view: '',
                description: ''
            },

        }
    },
    filters: {
        translate: function (dat, code, map) {
            if (code == 'type') {
                let transMap = ['', '页面', '按钮'];
                return transMap[dat];
            } else if (code == 'view') {
                let stateArr = ['', '显示', '不显示'];
                return stateArr[dat];
            }
        }
    },
    methods: {
        goDeeper: function (dats) {
            // console.log(dats);
        },

        formateDat: function (dats, inx) {
            for (let i in dats) {
                let Item = dats[i];
                if (inx) {
                    let tmp = [i];
                    Item.x = inx.concat(tmp);
                } else {
                    Item.x = [i];
                }
                Item.hide = true;
                this.storeArr.push(Item);
                if (Item.getMenuModules.length > 0) {
                    this.formateDat(Item.getMenuModules, Item.x);
                }
            }
        },

        arrEquires: function (arr1, arr2) {

            let eqs = true;
            for (let i in arr1) {
                if (arr1[i] != arr2[i]) {
                    eqs = false;
                    break;
                }
            };

            return eqs;

        },

        preFmate: function (rows) {
            if (rows.hide) {
                rows.hide = false;
                this.showFormate('open', rows.x);
            } else {
                rows.hide = true;
                this.showFormate('close', rows.x);
            }
        },

        showFormate: function (state, iArr) {

            // iArr 被点击行的 root 数组
            // state 执行 code

            let tempArr = [];
            for (let i in this.storeArr) {
                let item = this.storeArr[i];
                if (state == "init") {

                    if (item.x.length == 1) {
                        tempArr.push(item);
                    }
                } else {
                    if (this.arrEquires(iArr, item.x)) {
                        if (item.x.length - iArr.length == 1) {
                            tempArr.push(item);
                        }
                    }
                }
            }

            if (state == "open") {
                for (let i in this.showArr) {
                    let item = this.showArr[i];
                    if (this.arrEquires(iArr, item.x) && iArr.length == item.x.length) {
                        this.showArr.splice((parseInt(i) + 1), 0, ...tempArr);
                        break;
                    }
                }
            } else if (state == "close") {
                let transArr = [];
                for (let i in this.showArr) {
                    let toAdd = true;
                    for (let j in tempArr) {
                        if (this.arrEquires(tempArr[j].x, this.showArr[i].x)) {
                            toAdd = false;
                            break;
                        }
                    };
                    if (toAdd) {
                        transArr.push(this.showArr[i]);
                    }
                };

                this.showArr = transArr;
            } else if (state == "init") {
                this.showArr = tempArr;
            }

        },

        goSave: function () {

            let msg = '';
            if (!this.postDats.type) {
                msg = '请选择类型！';
            } else if (!this.postDats.view) {
                msg = '请选择显示与否！';
            } else if (!this.postDats.name) {
                msg = '请填写名称！';
            } else if (!this.postDats.url) {
                msg = '请输入菜单URL！';
            } else if (!this.postDats.iconUrl) {
                msg = '请输入菜单icon！';
            }

            if (msg) {
                this.$message({
                    showClose: true,
                    message: msg,
                    type: 'error'
                })
            } else {
                menuCreate(this.postDats).then(response => {
                    this.diaForAdd = false;
                    this.$message({
                        showClose: true,
                        message: '操作成功！',
                        type: 'success'
                    });
                    this.storeArr = [];
                    this.menuCreate();
                }).catch(error => {
                    this.diaForAdd = false;
                    this.$message({
                        showClose: true,
                        message: '操作失败！',
                        type: 'error'
                    })
                });
            }

        },

        goRemove: function (dat) {
            this.$confirm('确定要删除 "' + dat.name + '" 节点吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                let posts = {
                    id: dat.id
                }
                delDot(posts).then(response => {
                    this.$message({
                        showClose: true,
                        message: '删除成功！',
                        type: 'success'
                    });
                    this.storeArr = [];
                    this.menuCreate();
                }).catch(error => {
                    console.log(error);
                })
            }).catch(() => {});

        },

        btnTrans: function (state, dat) {

            if (state == "add") {
                this.diaForAdd = true;
                this.diaTitle = "添加";
                this.postDats = {
                    id: '',
                    pId: '',
                    iconUrl: '',
                    name: '',
                    type: '',
                    url: '',
                    view: '',
                    description: ''
                };
                if (dat) {
                    this.postDats.pId = dat.id;
                }

            } else if (state == "edit") {
                console.log(dat);
                this.diaForAdd = true;
                this.diaTitle = "编辑";
                this.postDats = {
                    id: dat.id,
                    pId: dat.pId,
                    iconUrl: dat.iconUrl,
                    name: dat.name,
                    type: dat.type,
                    url: dat.url,
                    view: dat.view,
                    description: dat.description
                };
            } else if (state == "remove") {
                this.goRemove(dat);
            }
        },

        menuCreate: function () {
            getMenu().then(response => {
                this.tableData = response.getMenuTreeModules;
                this.formateDat(this.tableData);
                this.showFormate("init");
            });
        }

    },
    created: function () {

        this.menuCreate();
    }
}
</script>

<style lang="scss">
.pgemnt-2 {
    padding: 6px 30px;
}
.pgemnt-2 .header{
    margin-top: 12px;
    margin-bottom: 12px;
}
.pgemnt-2 .goDeeper {
    cursor: pointer;
}

.goIcon {
    margin-right: 10px;
}

.pgemnt-2-dag .el-dialog__header {
    padding: 20px 18px 25px;
}

.pgemnt-2-dag .el-dialog__body {
    padding: 0px 30px;
    margin-bottom: 12px;
}

.pgemnt-2-dag .el-dialog__footer {
    padding-bottom: 30px;
}

.pgemnt-2-dag table {
    width: 100%;
    margin-top: 12px;
}

.pgemnt-2-dag table td {
    padding-bottom: 12px;
}

.pgemnt-2 .inpName {
    text-align: right;
    width: 90px;
    padding-right: 15px;
}

.pgemnt-2 .inpGup {
    margin-bottom: 12px;
    height: 45px;
    background: salmon;
}

.pgemnt-2 .newAdd {
    width: 90px;
}
</style>



// WEBPACK FOOTER //
// modelMent.vue?7a347e21